module.exports = __webpack_public_path__ + "img/heroku-stencil.de55481f.svg";